import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as authActions,
} from '../../../../redux/modules/auth';
import {
  actions as mainActions,
} from '../../../../redux/modules/main';

import AuthSectionView from './AuthSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './AuthSectionView';

const mapStateToProps = (): $StateProps => Object.freeze({
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  authenticate: (params) => dispatchAction(
    authActions.authenticate(params),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(AuthSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
